import { render } from "./EDSurge.vue?vue&type=template&id=6e769b13&scoped=true&ts=true"
import script from "./EDSurge.vue?vue&type=script&lang=ts"
export * from "./EDSurge.vue?vue&type=script&lang=ts"

import "./EDSurge.vue?vue&type=style&index=0&id=6e769b13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e769b13"]])

export default __exports__